import axiosInstance from '../../config'; // pre-configured axios instance

// export const acceptCopierService = async (token, data) => {
//   try {
//     const response = await axiosInstance.post(
//       '/copier/approve_copier_request',
//       data,

//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );



//     return {
//       data: response.data,
//       status: response.status,
//     };

//   } catch (error) {
//     console.error('Error  Accept copier status:', error);
//     return {
//       error: true,
//       message: error.response?.data || error.message,
//       status: error.response?.status || 500
//     };
//   }
// };


// Configuration Editing:axios-instance of pre-configured axios instance from (snippet four)

export const acceptCopierService = async (token, data) => {

  try {

    const response = await axiosInstance.post(
      '/copier/approve_copier_request',

      data,

      {

        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    );



    return {

      data: response.data,

      status: response.status,

    };

  }
  catch (error) {


    return {

      error: true,

      message: error.response?.data || error.message,

      status: error.response?.status || 500

    };

  }

};